import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken, apiError } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, obj=auth
  const [config, setConfig] = useState({ demo_mode: false });

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  const loadMe = useCallback(async () => {
    if (!getToken()) { setUser(null); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setToken(null);
      setUser(null);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const registerConsumer = async (payload) => {
    const { data } = await api.post("/auth/register-consumer", payload);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const registerReferralPartner = async (payload) => {
    const { data } = await api.post("/auth/register-referral-partner", payload);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("pc_verify_resend_at");
    setToken(null);
    setUser(null);
  };

  const refreshUser = loadMe;

  return (
    <AuthContext.Provider value={{ user, config, login, register, registerConsumer, registerReferralPartner, logout, refreshUser, setUser, apiError }}>
      {children}
    </AuthContext.Provider>
  );
}
